var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 18,
    height: 18,
    rx: 9,
    fill: "#7B8CC8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7216 9.076C13.0349 9.27183 13.0349 9.72817 12.7216 9.924L7.765 13.0219C7.43198 13.23 7 12.9906 7 12.5979L7 6.40212C7 6.00941 7.43198 5.76998 7.765 5.97812L12.7216 9.076Z",
    fill: "#F2F5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentVideo);
export default __webpack_public_path__ + "static/media/content-video.7575e172a5d46a85b1591c850013e215.svg";
export { ForwardRef as ReactComponent };